import styled from "styled-components";
export const Icon = styled.img`
    flex-direction: row;
    margin-top: 16px;
    width: 24px;
    height: 24px;
    gap: 32px;
    justify-content: center;
    margin: 32px 32px 0;
    @media (max-width: 576px){
      margin: 20px 20px 0;
        
    }

`
export const ContainerBar = styled.div`
    margin-left: 50px;
    margin: 0;
`
